import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {DialogService} from '@shared/services/dialog-service';
import {takeUntil} from 'rxjs/operators';
import {SnackBarService} from "@core/services/snack-bar.service";
import {select, Store} from "@ngrx/store";
import {IVirtualGridCollectionState} from "@shared/store/reducers/virtual-grid.reducer";
import {getVirtualGridFieldGroups} from "@shared/store/selectors/virtual-grid.selector";
import {pipe} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class PlatformToolPresetCountriesHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  private selectedTabModel: TabModel;
  sourceType: string;
  invalidateSubject: InvalidateSubject = new InvalidateSubject();
  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              private router: Router,
              private dialog: MatDialog,
              private dialogService: DialogService,
              private snackBarService: SnackBarService,
              private store: Store<IVirtualGridCollectionState>) {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceType = 'PresetCountries';
  }

  executeCommand(command: PlatformCommand) {
    console.log(command);
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
        if (commandHandler) {
          commandHandler.executeCommand(command, this);
          return;
      }
    }
    this.fuseSplashScreenService.hide();
    this.executeCommandApi(command);
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  executeCommandApi(command: PlatformCommand) {
    console.log('Executing PlatformCommand : ', command.name);
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }

  }

  valueChanged($event) {
    console.log($event);
    if (this.handleAction($event)) {
      return;
    }

  }

  handleAction($event: any): boolean {
    console.log($event);
    if ($event.action.id === 'Edit') {
      this.openEditor($event);
      return true;
    }
    if ($event.action.id === 'Delete') {
      this.deleteById($event);
      return true;
    }
    if ($event.action.id === 'Reset') {
      this.resetById($event);
      return true;
    }
    if ($event.action.id === 'Open') {
      this.openEditorByFieldDefination($event);
      return true;
    }
  }

  openEditorByFieldDefination(event) {
    const fieldDefination = event.fieldSection.fieldGroups[3].definitions[0];
    const newEvent = {
      item: event.item,
      fieldDefinition: fieldDefination
    };
    this.openEditor((newEvent));
  }

  resetById(event) {
    this.fuseSplashScreenService.show();
    const presetCountryId = event.item.cells['PresetCountryId'].value;
    const command = new PlatformCommand('ResetPresetCountriesToolLinkCommand', 'EntityChartApi');
    command.fieldValues['PresetCountryId'] = presetCountryId;
    this.commandService.executePlatformCommand(command).subscribe(( response: any) => {
      if (response.fieldValues['SnackBarMessage']) {
        const duration = response.fieldValues['SnackBarMessage'].length * 80;
        this.snackBarService.showInformation(response.fieldValues['SnackBarMessage'], duration);
      }
      this.invalidateSubject.invalidate();
      this.fuseSplashScreenService.hide();
    },
      error => {
        console.error('Failed to reset.');
        this.fuseSplashScreenService.hide();
      });
  }

  deleteById(event) {
    this.dialogService.showYesNoDialog('Delete Preset Country Report ?', 'Preset Country Report will be deleted')
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res.action === 'OK') {
        this.fuseSplashScreenService.show();
        const presetCountryId = event.item.cells['PresetCountryId'].value;
        const command = new PlatformCommand('DeletePresetCountriesToolLinkCommand', 'EntityChartApi');
        command.fieldValues['PresetCountryId'] = presetCountryId;
        this.commandService.executePlatformCommand(command).subscribe(( response: any) => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        },
          error => {
            console.error('Failed to delete.');
            this.fuseSplashScreenService.hide();
          });
      }
    });
  }

  openEditor(event: any) {
    const type = event.item.cells['Type'].value;
    const fieldKey = event.fieldDefinition.key;
    if ( type === 'Default' && fieldKey === 'Title') {
      this.snackBarService.showError('Default title cannot be edited.');
      return;
    }
    const minWidth = '800px';
    const maxWidth = '800px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        this.fuseSplashScreenService.show();
        const title = state.data.input.item.cells['Title'].value;
        const countryList = state.data.input.item.cells['Countries'].value;
        const presetCountryId = state.data.input.item.cells['PresetCountryId'].value;
        // const command = new UpdatePresetCountryCommand(updatedValue);
        const command = new PlatformCommand('UpdatePresetCountriesToolLinkCommand', 'EntityChartApi');
        command.fieldValues['Title'] = title;
        command.fieldValues['Countries'] = countryList;
        command.fieldValues['PresetCountryId'] = presetCountryId;
        this.commandService.executePlatformCommand(command).subscribe((res: any) => {
          console.log(res);
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        },
          error => {
            console.error('Failed to update.');
            this.fuseSplashScreenService.hide();
          });
      }
    });
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
